import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const TransmissionFilter = ({ type }) => {
  const { t } = useTranslation('search');
  const { data, prevData, params, updateParams } = useGetFiltersInfo();

  const options = data?.transmissions || prevData?.transmissions || [];

  const onChange = (newTransmissions) => {
    updateParams({
      transmissions: newTransmissions,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="transmission-filter"
      options={options}
      onChange={onChange}
      placeholder={t('Search')}
      type={type}
      value={params.transmissions}
    />
  );
};

TransmissionFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default TransmissionFilter;
